import angular from 'angular';
import achievementField from './achievementField';

export default angular
  .module('components.achievementField', [])
  .component('achievementField', achievementField).name;
